import React from "react";
// import { Icon } from "antd";
import { end_point } from './helper'
import axios from 'axios'
import { Redirect } from 'react-router-dom';


// async function LinkRedirect(props) {

//   console.log('Request Id:', props.linkId)

    // const response = await axios.get(`${end_point("links")}/${props.linkId}`, {
    //   // headers: {
    //   //   Authorization: `Bearer ${token}`,
    //   //   "Content-Type": "application/json"
    //   // }
    // });

// // console.log("RESPONSE", response.data)
// // props.history.push(`/${response.data}`)
// return <div>hallo</div>
// }

// export default LinkRedirect;

class RedirectLink extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect:false,
      link: "",
    };
  }

componentDidMount() {
this.getLink()

}

getLink = async() => {

  const response = await axios.get(`${end_point("links")}/${this.props.linkId}`, {
    // headers: {
    //   Authorization: `Bearer ${token}`,
    //   "Content-Type": "application/json"
    // }
  });
  console.log("RESPONSE", response)
  if(response.status === 200) {

  this.setState({redirect: true,
    link: response.data})
  } else {
    alert("This is not a valid link, please request a new link or contact support")
  }
}
  render() {
    const {redirect} = this.state;
   if(redirect){
    return <Redirect push to={`/${this.state.link}`}/> 
      
  

    
  } else {
    return <div className="full-page"><div className="loader cent"></div></div>
  }
}
}

export default RedirectLink;



